import dom from '../../../../wrapper/DomWrapper';
import getStateValue from '../../../../helpers/getStateValue';
import loadImage from '../../../../helpers/loadImage';
import genAbsoluteUrl from './genAbsoluteUrl';

const error = '<div class="picture-wrap_unavailable" />';

const addGridItemImages = (element, { previewImageUrl }) => {
  const gridThumb = dom.getElement('[data-grid-image]', element);

  if (!gridThumb) return;

  const { gridImage } = gridThumb.dataset;
  const fileStorage = getStateValue('apiUrls.fileStorageService');

  if (!fileStorage) return;

  const src = previewImageUrl && genAbsoluteUrl(fileStorage, previewImageUrl);

  if (gridImage === 'background') {
    if (!src) dom.addClass(gridThumb, 'blog-item__card-empty');
    else {
      loadImage(src)
        .then(() => {
          gridThumb.style['background-image'] = `url("${src}")`;
        })
        .catch(() => {
          dom.addHtml(dom.getElement('.blog-item__overlay', gridThumb), error);
        });
    }
  }

  if (gridImage === 'image') {
    const imageContainer = dom.getElement('.blog-item__thumbnails-img', gridThumb);
    const img = dom.createElement('img');
    imageContainer.appendChild(img);
    img.src = src;
    img.onerror = () => dom.addHtml(imageContainer, error);
  }
};

export default addGridItemImages;
